__turbopack_context__.v({
  "container": "StatCard-module-scss-module__w0WVaG__container",
  "statLabel": "StatCard-module-scss-module__w0WVaG__statLabel",
});
